import styled from 'styled-components';

export const RoutineListItemDiv = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-top: 1px solid ${({ theme }) => theme.palette.divider}88;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

export const Time = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  line-height: 19px;
  margin: 0px;
  font-weight: 600;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  line-height: 19px;
  margin: 0px;
`;

export const Description = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  line-height: 19px;
  margin: 0px;
`;

export const AllData = styled.div`
  vertical-align: middle;
  line-height: 90px;
  padding: 15px 24px;
`;
